import {
  ROUTE_JOB_PLACEMENT,
  ROUTE_USER_ADDED_JOB_PLACEMENTS,
  SOCIAL_AUTH_SAVE_DATA,
} from 'app-constants';
import { SECOND_JOB_PLACEMENT_STEP } from 'app-constants/job-placement-steps';
import PageTitle from 'components/common/page-title/PageTitle';
import Button from 'components/shared/button/Button';
import JobTrend from 'components/shared/job-trend/JobTrend';
import InfoCardTitle from 'components/shared/page-info-card/components/info-card-title/InfoCardTitle';
import PageInfoCard from 'components/shared/page-info-card/PageInfoCard';
import React, { FC, useEffect, useMemo } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useGlobalJobPlacementContext } from 'contexts/GlobalJobPlacementContext';
import { getCookie, removeCookie } from 'utils/AuthHelpers';
import { patchJobPlacement } from 'api';

const KEY_STEP_2 = {
  important: 'selected_choosing_employer_importance_options',
  motivation: 'selected_what_motivates_best_job_options',
  deal_break: 'selected_deal_breaker_options',
};

export const JPStepTwo: FC = () => {
  const {
    store: { jobPlacementForm, steps },
    handleClickStep,
    setJobPlacementForm,
    resetStep,
  } = useGlobalJobPlacementContext();

  const navigate = useNavigate();

  const context = useOutletContext<any>();

  const disabledButton = useMemo(() => {
    return (
      jobPlacementForm.selected_choosing_employer_importance_options.length === 0 ||
      jobPlacementForm.selected_what_motivates_best_job_options.length === 0 ||
      jobPlacementForm.selected_deal_breaker_options.length === 0
    );
  }, [
    jobPlacementForm.selected_choosing_employer_importance_options,
    jobPlacementForm.selected_what_motivates_best_job_options.length,
    jobPlacementForm.selected_deal_breaker_options.length,
  ]);

  const handleClickItem = (item, answer) => {
    if (item.key === 'important') {
      if (jobPlacementForm.selected_choosing_employer_importance_options.includes(answer.value)) {
        const filterSelected =
          jobPlacementForm.selected_choosing_employer_importance_options.filter(
            (typFilter: any) => typFilter !== answer.value
          );
        setJobPlacementForm({
          selected_choosing_employer_importance_options: filterSelected,
        });
      } else {
        setJobPlacementForm({
          selected_choosing_employer_importance_options: [
            ...jobPlacementForm.selected_choosing_employer_importance_options,
            answer.value,
          ],
        });
      }
    } else if (item.key === 'motivation') {
      if (jobPlacementForm.selected_what_motivates_best_job_options.includes(answer.value)) {
        const filterSelected = jobPlacementForm.selected_what_motivates_best_job_options.filter(
          (typFilter: any) => typFilter !== answer.value
        );
        setJobPlacementForm({
          selected_what_motivates_best_job_options: filterSelected,
        });
      } else {
        setJobPlacementForm({
          selected_what_motivates_best_job_options: [
            ...jobPlacementForm.selected_what_motivates_best_job_options,
            answer.value,
          ],
        });
      }
    } else if (item.key === 'deal_break') {
      if (jobPlacementForm.selected_deal_breaker_options.includes(answer.value)) {
        const filterSelected = jobPlacementForm.selected_deal_breaker_options.filter(
          (typFilter: any) => typFilter !== answer.value
        );
        setJobPlacementForm({
          selected_deal_breaker_options: filterSelected,
        });
      } else {
        setJobPlacementForm({
          selected_deal_breaker_options: [
            ...jobPlacementForm.selected_deal_breaker_options,
            answer.value,
          ],
        });
      }
    }
  };

  const handleClickNext = () => {
    navigate(`/${ROUTE_JOB_PLACEMENT}/step3`);
  };

  const handleClickBack = () => {
    navigate(`/${ROUTE_JOB_PLACEMENT}`);
  };

  useEffect(() => {
    const filterStep = steps.find((item) => item.id === 1);
    handleClickStep(filterStep);

    const data = getCookie(SOCIAL_AUTH_SAVE_DATA);

    if (data && data.data) {
      setJobPlacementForm({ ...data.data });
      removeCookie(SOCIAL_AUTH_SAVE_DATA);
      handleClickNext();
    }
  }, []);

  const handleCancelEdit = () => {
    navigate(`/${ROUTE_USER_ADDED_JOB_PLACEMENTS}/${context.jobPlacementInfo.id}`);
  };

  const handleUpdateJobPlacement = () => {
    if (disabledButton) return;

    patchJobPlacement(context.jobPlacementInfo.id, jobPlacementForm).then(() => {
      resetStep();
      navigate(`/${ROUTE_USER_ADDED_JOB_PLACEMENTS}/${context.jobPlacementInfo.id}`);
    });
  };

  return (
    <PageInfoCard classList={['center']}>
      <PageTitle type={'card'} title={'Tell us about your Cultural Preferences'} />

      <div className="info-card-content">
        {SECOND_JOB_PLACEMENT_STEP.map((item, index) => (
          <div className="card-section" key={index}>
            <InfoCardTitle {...item} stepItem={true} />
            <div className={'flexWrapper'}>
              {item.answers.map((answer: any, i) => (
                <JobTrend
                  key={i}
                  {...answer}
                  clickable={true}
                  onClick={() => handleClickItem(item, answer)}
                  selected={jobPlacementForm[KEY_STEP_2[item.key]].includes(answer.value)}
                />
              ))}
            </div>
          </div>
        ))}

        <div className="buttons-group">
          {!context ? (
            <>
              <Button text={'Go Back'} classList={['white']} onClick={handleClickBack} />
              <Button text={'Next Step'} onClick={handleClickNext} disabled={disabledButton} />
            </>
          ) : (
            <>
              <Button
                text="Save"
                classList={['smaller']}
                onClick={handleUpdateJobPlacement}
                disabled={disabledButton}
              />
              <Button text="Cancel" classList={['white']} onClick={handleCancelEdit} />
            </>
          )}
        </div>
      </div>
    </PageInfoCard>
  );
};
export default JPStepTwo;
